const noRefundPolicy = {
  effectiveDate: "Last updated on 23-Sept-2024",
  title: "Refund Policy",
  introduction:
    "At JAANO.AI, we prioritize customer satisfaction and transparency. Our goal is to provide high-quality AI-powered chatbot services that meet your expectations. However, due to the nature of our services, our refund policy is structured as follows:",
  sections: [
    {
      heading: "No Refunds",
      content:
        "Once a purchase is completed, refunds are generally not available. By subscribing to our services, you acknowledge and agree to this policy. This is because our platform operates on a credit-based system, and once credits are allocated, they cannot be revoked or resold.",
    },
    {
      heading: "Exceptions – When Refunds May Be Considered",
      content:
        "While we maintain a strict no-refund policy, we may offer refunds at our sole discretion in the following cases:",
      exceptions: [
        {
          title: "Technical Issues Preventing Usage",
          description:
            "If you encounter a critical technical issue that prevents you from accessing or utilizing our service, and our support team is unable to resolve it, we may approve a refund.",
        },
        {
          title: "Incorrect Product/Service Delivery",
          description:
            "If an incorrect plan, credit allocation, or service was delivered due to a system error, we will review your case for a possible refund.",
        },
        {
          title: "Refund Requests Within 7 Days",
          description:
            "Refunds may be considered within 7 days of purchase, subject to the following conditions:",
          conditions: [
            "A refund will only be issued if none of the purchased credits have been used.",
            "If credits have been used, the refund amount will be adjusted based on the number of credits consumed and the duration the account has been active.",
          ],
        },
      ],
    },
    {
      heading: "Refund Processing & Deductions",
      content:
        "If your refund request qualifies under the exceptions listed above, the refund amount will be calculated as follows:",
      refundCriteria: [
        {
          condition: "If 0% of credits have been used",
          refund: "80% refund, deducting 20% handling charges.",
        },
        {
          condition: "If some credits have been used",
          refund:
            "In addition to 20% handling charges, a proportional amount will be deducted based on the number of credits consumed and the time elapsed.",
        },
        {
          condition: "If all credits have been used",
          refund: "No refund will be provided.",
        },
      ],
      processingTime: `If approved, refunds will be issued through the original payment method within 3–5 business days. The funds should be reflected in your account within 3–5 working days, subject to your bank or payment provider’s processing times.`,
    },
    {
      heading: "How to Request a Refund",
      content:
        "If you believe you qualify for a refund under the above exceptions, please contact our support team with the following details:",
      requestDetails: [
        "Order ID and transaction details",
        "Reason for the refund request (include screenshots or evidence, if applicable)",
        "Description of the issue",
      ],
      email: "info@jaano.ai",
      reviewTime:
        "Our team will review your request and respond within 3-5 business days.",
    },
    {
      heading: "Contact Us",
      content:
        "For any questions or concerns regarding this refund policy, please reach out to our team.",
      copyright: "© 2025 Jaano.ai, Inc.",
      email: "info@jaano.ai",
    },
  ],
};

export default noRefundPolicy;
